exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2V8rMrXVs4j-_Vu7khTB8p{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1.14286rem;font-weight:400;letter-spacing:.07143rem;line-height:1.25}._2V8rMrXVs4j-_Vu7khTB8p div{vertical-align:middle}._3EiGYGRu5F8UlEGbSxobbt{margin:0 .35714rem}._1UEXYitCixRB_WUgdCesni{font-size:1.28571rem;margin-left:1.07143rem;min-width:0;padding:0 .57143rem;vertical-align:inherit}._3-sCi-DvovjR6x1d6ZNEle{border-top:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"Concerns_filters": "_2V8rMrXVs4j-_Vu7khTB8p",
	"Concerns_filters_input": "_3EiGYGRu5F8UlEGbSxobbt",
	"Concerns_filters_button": "_1UEXYitCixRB_WUgdCesni",
	"Concerns_expansionButton": "_3-sCi-DvovjR6x1d6ZNEle"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.3/node_modules/omni-common-ui/postcss.config.js"}}!./containers/UserDashboard/AcademicInfo/Concerns/style.postcss
// module id = 2117
// module chunks = 0